import { Inject, Injectable } from '@angular/core';
import { HandleError, HttpUtility, PacimHttpErrorHandlerService } from '@core/http';
import { PacimUtilityEntity } from '../enumeration';
import { API_BASE_PACIM_URL } from './config.service';
import { UtilityPacimService } from './utilities.service';

@Injectable()
export class ServiceLinePacimPdsUtilityService extends UtilityPacimService {
  entityType = PacimUtilityEntity.PostDecisionSupport;

  handleError:HandleError;

  constructor(
    httpUtility: HttpUtility,
    @Inject(API_BASE_PACIM_URL) apiBaseUrl: string,
    pacimHttpErrorHandler: PacimHttpErrorHandlerService
  ) {
    super(httpUtility, apiBaseUrl);
    this.handleError = pacimHttpErrorHandler.createHandleError('ServiceLinePacimPdsUtilityService');
  }
}
